export const textLang: Record<string, Record<string, string>> = {
    us: {
        rules: 'Rules',
        start: 'Start Answering',
        no_start: 'The event has not started yet',
        finshed: 'Completed',
        view_log: 'View Answering History',
        welcome: 'Come on!\nGet some Ecocredits',
        rewards: 'Rewards for Winning',
        ecoCredits: 'EcoCredits',
        coupons: 'Coupons',
        single: 'Single choice question',
        multiple: 'Multiple choice question',
        continue: 'Continue to Answer',
        analysis: 'Explanation',
        next: 'Next',
        prev: 'Prev',
        finshed_title: 'I have answered all the questions',
        correct: 'Correct',
        error: 'Incorrect',
        submit: 'Submit',
        view_answer: 'View Answer Records',
        history_title: 'Answering History',
        award_record: 'Award Records',
        answer_record: 'Answer Records',
        award_date: 'Date',
        award_action: 'Action',
        award_rewards: 'Rewards',
        award_status: 'Status',
        answer_date: 'Date',
        answer_title: 'Title',
        answer_result: 'Result',
        correctly: 'Answer the question correctly',
        received: 'Received',
        view_more: '',
        pending: '',
        history_note: '',
        no_history_note: '',
        not_eligible: 'You are not eligible to participate in this event.',
        date_of_event: 'Date of Event',
    },
    de: {
        rules: 'So können Sie teilnehmen:',
        start: 'Beantworten starten',
        no_start: 'Das Ereignis hat noch nicht begonnen',
        finshed: 'abgeschlossen',
        view_log: 'Antwortverlauf anzeigen',
        welcome: 'Sei Teil des Wahnsinns!\nJetzt teilnehmen',
        rewards: 'Belohnungen für den Gewinn',
        ecoCredits: 'EcoCredits',
        coupons: 'Gutscheine',
        single: 'Einzelauswahlfrage',
        multiple: 'Mehrfachauswahlfrage',
        continue: 'Weiter zur Antwort',
        analysis: 'Explanation',
        next: 'Weiter',
        prev: 'Vorherige',
        finshed_title: 'Ich habe alle Fragen beantwortet',
        correct: 'Richtig',
        error: 'Falsch',
        submit: 'Einreichen',
        view_answer: 'Antwortprotokolle anzeigen',
        history_title: 'Antwortverlauf',
        award_record: 'Auszeichnungsdatensätze',
        answer_record: 'Antwortdatensätze',
        award_date: 'Datum',
        award_action: 'Aktion',
        award_rewards: 'Rewards',
        award_status: 'Status',
        answer_date: 'Datum',
        answer_title: 'Titel',
        answer_result: 'Ergebnis',
        correctly: 'Beantworte die Frage korrekt',
        received: 'Erhalten',
        join_community: 'Highlights dieses Quiz: Unsere EcoFlow Communitymitglieder haben ihre Fragen beigesteuert.',
        join_community_btn: 'Community beitreten',
        not_eligible: 'Sie sind nicht berechtigt, an diesem Event teilzunehmen.',
        date_of_event: 'Datum des Events',
    },
    es: {
        rules: 'Cómo participar',
        start: 'Comenzar a responder',
        no_start: 'El evento aún no ha comenzado',
        finshed: 'completado',
        view_log: 'Ver historial de respuestas',
        welcome: '¡Sé parte de la locura!\nUnirse ahora',
        rewards: 'Recompensas por ganar',
        ecoCredits: 'EcoCredits',
        coupons: 'Cupones',
        single: 'Pregunta de opción única',
        multiple: 'Pregunta de opción múltiple',
        continue: 'Continua per rispondere',
        analysis: 'Análisis',
        next: 'Siguiente',
        prev: 'Anterior',
        finshed_title: 'He respondido todas las preguntas',
        correct: 'Correcto',
        error: 'Incorrecto',
        submit: 'Invia',
        view_answer: 'Voir les réponses enregistrées',
        history_title: 'Historial de respuestas',
        award_record: 'Registros de premios',
        answer_record: 'Registros de respuestas',
        award_date: 'Fecha',
        award_action: 'Acción',
        award_rewards: 'Rewards',
        award_status: 'Estado',
        answer_date: 'Fecha',
        answer_title: 'Título',
        answer_result: 'Resultado',
        correctly: 'Responde la pregunta correctamente',
        received: 'Recibido',
        not_eligible: 'No eres elegible para participar en este evento.',
        date_of_event: 'Fecha del evento',
    },
    eu: {
        rules: 'How to Participate',
        start: 'Start Answering',
        no_start: 'The event has not started yet',
        finshed: 'Completed',
        view_log: 'View Answering History',
        welcome: 'Be a Part of the Madness!\nJoin Now!',
        rewards: 'Rewards for Winning',
        ecoCredits: 'EcoCredits',
        coupons: 'Coupons',
        single: 'Single choice question',
        multiple: 'Multiple choice question',
        continue: 'Continue to Answer',
        analysis: 'Explanation',
        next: 'Next',
        prev: 'Prev',
        finshed_title: 'I have answered all the questions',
        correct: 'Correct',
        error: 'Incorrect',
        submit: 'Submit',
        view_answer: 'View Answer Records',
        history_title: 'Answering History',
        award_record: 'Award Records',
        answer_record: 'Answer Records',
        award_date: 'Date',
        award_action: 'Action',
        award_rewards: 'Rewards',
        award_status: 'Status',
        answer_date: 'Date',
        answer_title: 'Title',
        answer_result: 'Result',
        correctly: 'Answer the question correctly',
        received: 'Received',
        not_eligible: 'You are not eligible to participate in this event.',
        date_of_event: 'Date of Event',
    },
    fr: {
        rules: 'Comment participer ?',
        start: 'Commencer le quiz',
        no_start: "L’événement n'a pas encore commencé",
        finshed: 'Terminé',
        view_log: 'Voir l’historique des réponses',
        welcome: 'Faites partie de la folie!\nRejoignez-nous maintenant',
        rewards: 'Récompenses pour les gagnants',
        ecoCredits: 'EcoCredits',
        coupons: 'Coupons',
        single: 'Question à choix unique',
        multiple: 'Question à choix multiple',
        continue: 'Passer au Réponse',
        analysis: 'Analyse',
        next: 'Suivant',
        prev: 'Précédent',
        finshed_title: 'J’ai répondu à toutes les questions',
        correct: 'Bonne réponse',
        error: 'Mauvaise réponse',
        submit: 'Envoyer',
        view_answer: 'Voir les réponses enregistrées',
        history_title: 'Historique des réponses',
        award_record: 'Archive des récompenses',
        answer_record: 'Archives des réponses',
        award_date: 'Date',
        award_action: 'Action',
        award_rewards: 'Rewards',
        award_status: 'Status',
        answer_date: 'Date',
        answer_title: 'Titre',
        answer_result: 'Résultat',
        correctly: 'Saurez-vous répondre à cette question',
        received: 'Reçu',
        join_community: 'Points forts de ce quiz : des utilisateurs de la communauté EcoFlow ont contribué avec leurs questions.',
        join_community_btn: 'Rejoignez notre communauté',
        not_eligible: "Vous n'êtes pas éligible pour participer à cet événement.",
        date_of_event: "Date de l'événement",
    },
    it: {
        rules: 'Come partecipare',
        start: 'Inizia a rispondere',
        no_start: "L'evento non è ancora iniziato",
        finshed: 'completato',
        view_log: 'Visualizza la cronologia delle risposte',
        welcome: 'Fai parte del divertimento!\nUnisciti ora',
        rewards: 'Ricompense per la vittoria',
        ecoCredits: 'EcoCredits',
        coupons: 'coupon',
        single: 'Pregunta de opción única',
        multiple: 'Pregunta de opción múltiple',
        continue: 'Continuar para responder',
        analysis: 'Analisi',
        next: 'Avanti',
        prev: 'Indietro',
        finshed_title: 'Ho risposto a tutte le domande',
        correct: 'Corretto',
        error: 'Errato',
        submit: 'Enviar',
        view_answer: 'Voir les réponses enregistrées',
        history_title: 'Cronologia delle risposte',
        award_record: 'Record delle premiazioni',
        answer_record: 'Record delle risposte',
        award_date: 'Date',
        award_action: 'Azione',
        award_rewards: 'Rewards',
        award_status: 'Stato',
        answer_date: 'Date',
        answer_title: 'Titolo',
        answer_result: 'Risultato',
        correctly: 'Rispondi correttamente alla domanda',
        received: 'Ricevuti',
        join_community: 'Punti salienti di questo quiz: le domande sono fornite dagli utenti di EcoFlow Italia Gruppo Facebook',
        join_community_btn: 'Rejoignez notre communauté',
        not_eligible: 'Non hai l’idoneità per partecipare a questo evento.',
        date_of_event: 'Data dell’evento',
    },
    jp: {
        rules: '条件',
        start: '回答をはじめる',
        no_start: '本イベントはまだ始まっていません',
        finshed: '完了した',
        view_log: '回答履歴を見る',
        welcome: '狂気の一部になろう！\n今すぐ参加',
        rewards: '勝利ボーナス特典',
        ecoCredits: 'ポイント',
        coupons: 'Coupons',
        single: '単一選択肢問題',
        multiple: '複数選択肢問題',
        continue: '回答を続ける',
        analysis: '詳細',
        next: '次へ',
        prev: '前へ',
        finshed_title: 'すべての質問に回答しました',
        correct: '正解',
        error: '不正解',
        submit: '回答する',
        view_answer: '回答記録を表示する',
        history_title: '回答履歴',
        award_record: '獲得ボーナス記録',
        answer_record: '回答記録',
        award_date: '日付',
        award_action: '内容',
        award_rewards: '特典',
        award_status: 'ステータス',
        answer_date: '日付',
        answer_title: '件名',
        answer_result: '結果',
        correctly: '質問に正確に答えてください',
        received: '獲得',
        not_eligible: 'まだミッションをクリアしていません',
        date_of_event: '時刻',
    },
    kr: {
        rules: '포인트 사용 규칙',
        start: '回答をはじめる',
        no_start: '本イベントはまだ始まっていません',
        finshed: '完了した',
        view_log: '回答履歴を見る',
        welcome: '狂気の一部になろう！\n今すぐ参加',
        rewards: '勝利ボーナス特典',
        ecoCredits: 'EcoCredits',
        coupons: 'Coupons',
        single: '単一選択肢問題',
        multiple: '複数選択肢問題',
        continue: '回答を続ける',
        analysis: '詳細',
        next: '次へ',
        prev: '前へ',
        finshed_title: 'すべての質問に回答しました',
        correct: '正解',
        error: '不正解',
        submit: '送信',
        view_answer: '回答記録を表示する',
        history_title: '回答履歴',
        award_record: '獲得ボーナス記録',
        answer_record: '回答記録',
        award_date: '日付',
        award_action: '内容',
        award_rewards: '特典',
        award_status: 'ステータス',
        answer_date: '日付',
        answer_title: '件名',
        answer_result: '結果',
        correctly: '質問に正確に答えてください',
        received: '獲得',
        not_eligible: '이 이벤트에 참여할 자격이 없습니다',
        date_of_event: '이벤트 날짜',
    },
    uk: {
        rules: 'How to Participate',
        start: 'Start Answering',
        no_start: 'The event has not started yet',
        finshed: 'Completed',
        view_log: 'View Answering History',
        welcome: 'Be a Part of the Madness!\nJoin Now!',
        rewards: 'Rewards for Winning',
        ecoCredits: 'EcoCredits',
        coupons: 'Coupons',
        single: 'Single choice question',
        multiple: 'Multiple choice question',
        continue: 'Continue to Answer',
        analysis: 'Explanation',
        next: 'Next',
        prev: 'Prev',
        finshed_title: 'I have answered all the questions',
        correct: 'Correct',
        error: 'Incorrect',
        submit: 'Submit',
        view_answer: 'View Answer Records',
        history_title: 'Answering History',
        award_record: 'Award Records',
        answer_record: 'Answer Records',
        award_date: 'Date',
        award_action: 'Action',
        award_rewards: 'Rewards',
        award_status: 'Status',
        answer_date: 'Date',
        answer_title: 'Title',
        answer_result: 'Result',
        correctly: 'Answer the question correctly',
        received: 'Received',
        not_eligible: 'You are not eligible to participate in this event.',
        date_of_event: 'Date of Event',
    },
    za: {
        rules: 'Rules',
        start: 'Start Answering',
        no_start: 'The event has not started yet',
        finshed: 'Completed',
        view_log: 'View Answering History',
        welcome: 'Come on!\nGet some Ecocredits',
        rewards: 'Rewards for Winning',
        ecoCredits: 'EcoCredits',
        coupons: 'Coupons',
        single: 'Single choice question',
        multiple: 'Multiple choice question',
        continue: 'Continue to Answer',
        analysis: 'Explanation',
        next: 'Next',
        prev: 'Prev',
        finshed_title: 'I have answered all the questions',
        correct: 'Correct',
        error: 'Incorrect',
        submit: 'Submit',
        view_answer: 'View Answer Records',
        history_title: 'Answering History',
        award_record: 'Award Records',
        answer_record: 'Answer Records',
        award_date: 'Date',
        award_action: 'Action',
        award_rewards: 'Rewards',
        award_status: 'Status',
        answer_date: 'Date',
        answer_title: 'Title',
        answer_result: 'Result',
        correctly: 'Answer the question correctly',
        received: 'Received',
        not_eligible: 'You are not eligible to participate in this event.',
        date_of_event: 'Date of Event',
    },
    br: {
        rules: 'Regras',
        start: 'Responder agora',
        no_start: 'O evento não começou ainda',
        finshed: 'Concluído',
        view_log: 'Ver histórico',
        welcome: 'Vamos lá! \nGanhe alguns EcoCredits',
        rewards: 'Recompensas por vitória',
        ecoCredits: 'EcoCredits',
        coupons: 'Cupons',
        single: 'Questão de escolha única',
        multiple: 'Questão de múltipla escolha',
        continue: 'Continue a responder',
        analysis: 'Explicação',
        next: 'Avançar',
        prev: 'Voltar',
        finshed_title: 'Respondi a todas as questões',
        correct: 'Correto',
        error: 'Incorreto',
        submit: 'Enviar',
        view_answer: 'Ver registros de respostas',
        history_title: 'Histórico de respostas',
        award_record: 'Registros de recompensa',
        answer_record: 'Registros de respostas',
        award_date: 'Date',
        award_action: 'Ação',
        award_rewards: 'Recompensas',
        award_status: 'Status',
        answer_date: 'Date',
        answer_title: 'Título',
        answer_result: 'Resultado',
        correctly: 'Responda à pergunta corretamente',
        received: 'Recebidos',
        view_more: '',
        pending: '',
        history_note: '',
        no_history_note: '',
        not_eligible: 'Você não é elegível para participar deste evento.',
        date_of_event: 'Data do evento',
    },
    mx: {
        rules: 'Reglas',
        start: 'Responder ahora',
        no_start: 'El evento aún no ha comenzado',
        finshed: 'Completado',
        view_log: 'Ver historial',
        welcome: '¡Vamos!\n Consigue algunos EcoCréditos',
        rewards: 'Recompensas por ganar',
        ecoCredits: 'EcoCréditos',
        coupons: 'Cupones',
        single: 'Pregunta de una sola opción',
        multiple: 'Pregunta de selección múltiple',
        continue: 'Continuar a la respuesta',
        analysis: 'Explicación',
        next: 'Siguiente',
        prev: 'Anterior',
        finshed_title: 'Contesté todas las preguntas',
        correct: 'Correcta',
        error: 'Incorrecta',
        submit: 'Enviar',
        view_answer: 'Ver registros de respuestas',
        history_title: 'Historial de respuestas',
        award_record: 'Registros de recompensas',
        answer_record: 'Registros de respuestas',
        award_date: 'Fecha',
        award_action: 'Acción',
        award_rewards: 'Recompensas',
        award_status: 'Estado',
        answer_date: 'Fecha',
        answer_title: 'Título',
        answer_result: 'Resultado',
        correctly: 'Responda correctamente a la pregunta',
        received: 'Recibido',
        view_more: '',
        pending: '',
        history_note: '',
        no_history_note: '',
        not_eligible: 'No aplica para participar en este evento.',
        date_of_event: 'Fecha del evento',
    },
    ph: {
        rules: 'Rules',
        start: 'Start Answering',
        no_start: 'The event has not started yet',
        finshed: 'Completed',
        view_log: 'View Answering History',
        welcome: 'Come on!\nGet some Ecocredits',
        rewards: 'Rewards for Winning',
        ecoCredits: 'EcoCredits',
        coupons: 'Coupons',
        single: 'Single choice question',
        multiple: 'Multiple choice question',
        continue: 'Continue to Answer',
        analysis: 'Explanation',
        next: 'Next',
        prev: 'Prev',
        finshed_title: 'I have answered all the questions',
        correct: 'Correct',
        error: 'Incorrect',
        submit: 'Submit',
        view_answer: 'View Answer Records',
        history_title: 'Answering History',
        award_record: 'Award Records',
        answer_record: 'Answer Records',
        award_date: 'Date',
        award_action: 'Action',
        award_rewards: 'Rewards',
        award_status: 'Status',
        answer_date: 'Date',
        answer_title: 'Title',
        answer_result: 'Result',
        correctly: 'Answer the question correctly',
        received: 'Received',
        view_more: '',
        pending: '',
        history_note: '',
        no_history_note: '',
        not_eligible: 'You are not eligible to participate in this event.',
        date_of_event: 'Date of Event',
    },
    nl: {
        rules: 'Hoe deel te nemen',
        start: 'Begin met antwoorden',
        no_start: 'Het evenement is nog niet begonnen',
        finshed: 'Voltooid',
        view_log: 'Bekijk antwoordgeschiedenis',
        welcome: 'Oh, serieus!\nKrijg wat Ecocredits',
        rewards: 'Beloningen voor het winnen',
        ecoCredits: 'EcoCredits',
        coupons: 'Kortingsbonnen',
        single: 'Vragen met één keuze',
        multiple: 'Meerkeuzevragen',
        continue: 'Ga door met antwoorden',
        analysis: 'Uitleg',
        next: 'Volgende',
        prev: 'Vorige',
        finshed_title: 'Ik heb alle vragen beantwoord',
        correct: 'Correct',
        error: 'Incorrect',
        submit: 'Versturen',
        view_answer: 'Antwoordgegevens bekijken',
        history_title: 'Antwoordengeschiedenis',
        award_record: 'Beloningsgegevens',
        answer_record: 'Antwoordgegevens',
        award_date: 'Datum',
        award_action: 'Actie',
        award_rewards: 'Beloningen',
        award_status: 'Status',
        answer_date: 'Datum',
        answer_title: 'Titel',
        answer_result: 'Resultaat',
        correctly: 'Beantwoord de vraag correct',
        received: 'Ontvangen',
        not_eligible: 'U bent niet in aanmerking om deel te nemen aan dit evenement.',
        date_of_event: 'Datum van evenement',
    },
};
